export enum Languages {
  ENGLISH = 'En',
  FRENCH = 'Fr',
  PORTUGUESE = 'Po',
  SPANISH = 'Sp',
}
